module.exports = __webpack_public_path__ + "8e6552d89e639805d997e25dbfbe56d9.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/AS.svg
// module id = QEKa
// module chunks = 0